import type { AllRouteEndpoints } from "../routeTypes";
export const engagementAppGroupIdCreateEmailTestCacheKeys: AllRouteEndpoints[] = [];
export const engagementAppGroupIdCreateEmailTest = "/engagement/:app_group_id/create_email_test";
